import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Main from "../Screens/Main";

const Router: React.FC = () => {

  useEffect(() => {
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Main />}></Route>
      </Routes>
    </>
  );
};
export default Router;
